import React from 'react';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import GuestSiteMenu from "../guest_menu";
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ViewEquipmentTable from './equipment_table';
import ReactGA from "react-ga4"

class ServiceRequestForm extends React.Component {
    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);
        this.state = {
            user: userExists ? props.location.state.user : {},
            userExists: userExists,
            input: {
                requestorFirstname: userExists ? props.location.state.user.firstname : '',
                requestorLastname: userExists ? props.location.state.user.lastname: '',
                requestorEmail: userExists ? props.location.state.user.email : '',
                requestorPhone: userExists ? props.location.state.user.phone : '',
                requestUrgency: 'Same day service',
                propertyState:'DC'

            },
            accounts: [],
            buildings: [],
            buildingOptions: [],
            selectedBuilding: null,
            errors: {},
            loading: false
        };

        this.fileControl = React.createRef();
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleBuildingChange = this.handleBuildingChange.bind(this);
        this.handleSameAsCheckbox = this.handleSameAsCheckbox.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showButton = this.showButton.bind(this);
        this.createSelectItems = this.createSelectItems.bind(this);
    }

    componentDidMount() {
        if (this.state.userExists) {
            axios.get(`${Constants.apiURL}/api/Payment/accounts`, {
                params: {
                    username: this.state.user.username,
                    isWork:true
                }
            }).then(response => {
                if (response.data) {
                    let input = this.state.input;
                    input.accountNumber = response.data[0].accountID;
                    this.setState(() => ({
                        accounts: response.data,
                        input: input
                    }), this.getBuildingsForAccount);
                }
            }).catch((response) => {
                // ? Show to user that request is failed
                this.setState({ errors: [response] })
                this.setState({ loading: false });
                console.log('request failed', response)
            });
        }
    }

    getBuildingsForAccount() {
        console.log(this.state);
        axios.get(`${Constants.apiURL}/api/Request/GetBuildingsByAccount`, {
            params: {
                accountID: this.state.input.accountNumber
            }
        }).then(response => {
            if (response.data) {
                let items = [];
                items = response.data.map(function (item) {
                    return { 'label': item.buildingName.trim() + ' | ' + item.address.trim(), 'value': item };
                });
                console.log(items);
                this.setState(() => ({
                    buildings: response.data,
                    buildingOptions: items
                }));
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    createSelectItems() {
        let items = [];
        items = this.state.accounts.map(function (item) {
            return <option value={item.accountID}>{item.accountID} | {item.accountName}</option>;
        });
        return items;
    }

    handleBuildingChange(selectedOption) {
        console.log(selectedOption);
        let buildingInfo = this.state.input;

        if (selectedOption == null) {
            buildingInfo.propertyName = '';
            buildingInfo.propertyAddress = '';
            buildingInfo.propertyState = '';
            buildingInfo.propertyZip = '';
            buildingInfo.propertyCity = '';
            buildingInfo.propertyOwner = '';
            buildingInfo.propertySuite = '';
        }
        else {
            buildingInfo.propertyName = selectedOption.value.buildingName.trim();
            buildingInfo.propertyAddress = selectedOption.value.address.trim();
            buildingInfo.propertyState = selectedOption.value.state.trim();
            buildingInfo.propertyZip = selectedOption.value.zip.trim();
            buildingInfo.propertyCity = selectedOption.value.city.trim();
            buildingInfo.propertyOwner = '';
            buildingInfo.propertySuite = '';
        }

        console.log(buildingInfo);
        this.setState({
            selectedBuilding: selectedOption,
            input: buildingInfo
        });
    }

    handleFormChange(event) {
        let input = this.state.input;
        let errors = this.state.errors;

        if (event.target.name.indexOf("Zip") != -1) {
            if (!String(event.target.value).match(/(^[0-9-]{0,11}$)/))
            {
                return;
            }
        }

        if (event.target.name == 'accountNumber') {
            input[event.target.name] = event.target.value;
            this.setState({
                input,
                selectedBuilding: null,
                errors
            }, this.getBuildingsForAccount);
            return;
        }

        input[event.target.name] = event.target.value;
        if (!!errors[event.target.name]) {
            errors[event.target.name] = null;
        }

        this.setState({
            input,
            errors
        });
    }

    handleSameAsCheckbox(event) {
        console.log(event);
        let input = this.state.input;
        if (event.target.name == "spocSameAsCheckbox") {
            input.spocFirstname = input.requestorFirstname;
            input.spocLastname = input.requestorLastname;
            input.spocEmail = input.requestorEmail;
            input.spocPhone = input.requestorPhone;
        }
        else if (event.target.name == "bpocSameAsCheckbox") {
            input.bpocFirstname = input.requestorFirstname;
            input.bpocLastname = input.requestorLastname;
            input.bpocEmail = input.requestorEmail;
            input.bpocPhone = input.requestorPhone;
        }

        this.setState({ input });
    }

    validate() {
        let input = this.state.input;
        let errors = {};
        let isValid = true;


        if (!input["requestorFirstname"]) {
            isValid = false;
            errors["requestorFirstname"] = "Please enter your first name.";
        }
        if (!input["requestorLastname"]) {
            isValid = false;
            errors["requestorLastname"] = "Please enter your last name.";
        }

        if (!input["requestorPhone"] || !String(input["requestorPhone"])
            .match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/)) {
            isValid = false;
            errors["requestorPhone"] = "Invalid phone number.";
        }

        if (!input["requestorEmail"] || !String(input["requestorEmail"])
            .toLowerCase()
            .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )) {
            isValid = false;
            errors["requestorEmail"] = "Invalid email address.";
        }
        if (!input["propertyOwner"]) {
            isValid = false;
            errors["propertyOwner"] = "Please enter the property name.";
        }
        if (!input["propertyName"]) {
            isValid = false;
            errors["propertyName"] = "Please enter the property name.";
        }

        if (!input["propertyAddress"]) {
            isValid = false;
            errors["propertyAddress"] = "Please enter the street address.";
        }

        if (!input["propertyCity"]) {
            isValid = false;
            errors["propertyCity"] = "Please enter the city.";
        }

        if (!input["propertyState"]) {
            isValid = false;
            errors["propertyState"] = "Invalid.";
        }

        if (!input["propertyZip"]) {
            isValid = false;
            errors["propertyZip"] = "Invalid.";
        }
        if (!input["requestDetails"]) {
            isValid = false;
            errors["requestDetails"] = "Invalid.";
        }

        this.setState({
            errors: errors
        });
        return isValid;
    }

    handleSubmit(event) {
        event.preventDefault();
        if (!this.validate()) {
            alert('Please fill in required fields to proceed.');
            return;
        }
        this.setState({ loading: true });

        let formData = new FormData();
        for (var key in this.state.input) {
            formData.append(key, this.state.input[key]);
        }

        for (var i = 0; i < this.fileControl.current.files.length; i++) {
            formData.append('attachments', this.fileControl.current.files[i]);
        }

        formData.append('equipment', JSON.stringify(this.equipmentTable.state.data));
        formData.append('username', this.state.user.username);
        /*for (var i = 0; i < this.equipmentTable.state.data.length; i++) {
            console.log(this.equipmentTable.state.data[i]);
        }*/

        axios.post(`${Constants.apiURL}/api/Request/service`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            if (response.data && response.data == true) {
                ReactGA.event({
                    category: 'Request',
                    action: 'Service',
                    label: 'Service Request'
                });
                alert('Your service request has been received, and we will reach out with any questions. Please expect a confirmation email once service has been setup by our team.');
                this.props.history.push({
                    pathname: '/orders',
                    state: {
                        user: this.state.user
                    }
                });
            }
            else {
                alert('Error processing your request');
            }
            this.setState({ loading: false });
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                Submit
            </Button>
        }
    }

    render() {

        const { selectedBuilding, buildingOptions } = this.state;
        return (
            <div>
                {(this.state.userExists ? <SiteMenu user={this.state.user} currentPage='serviceRequest' /> : <GuestSiteMenu currentPage='serviceRequest' />)}

                <Form onSubmit={this.handleSubmit} style={{ padding: 5 }} noValidate>

                    <Row className="form-row-first">
                        <Form.Label style={{ marginBottom: '0px' }} className="form-header">Service Request Form</Form.Label>
                        <Form.Label style={{ fontSize: '15px', marginTop: '-5px', paddingTop: '0px', fontStyle: 'italic' }}>Provide request information below. A member of our team will process your request and call with any questions.</Form.Label>

                        <Form.Label className="form-header">Service Location</Form.Label>
                        <Col md={6}>
                            <Form.Group className="mb-3" controlId="accountNumber" hidden={!this.state.userExists} >
                                <Form.Label>Account Number</Form.Label>
                                <Form.Select name="accountNumber" onChange={this.handleFormChange}>
                                    {this.createSelectItems()}
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-3" controlId="building" hidden={!this.state.userExists} >
                                <Form.Label>Building</Form.Label>
                                <Select
                                    value={selectedBuilding}
                                    onChange={this.handleBuildingChange}
                                    options={buildingOptions}
                                    isClearable={true}
                                    placeholder='(Optional) Select a building...'
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formProperyName">
                                <Form.Label>Property name</Form.Label>
                                <Form.Control type="input" name="propertyName" value={this.state.input.propertyName} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.propertyName} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formOwner">
                                <Form.Label>Property owned or managed by</Form.Label>
                                <Form.Control type="input" name="propertyOwner" value={this.state.input.propertyOwner} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.propertyOwner} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formStreetAddress">
                                <Form.Label>Street address</Form.Label>
                                <Form.Control type="input" name="propertyAddress" value={this.state.input.propertyAddress} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.propertyAddress} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formSuite">
                                <Form.Label>Suite (if applicable)</Form.Label>
                                <Form.Control type="input" name="propertySuite" value={this.state.input.propertySuite} onChange={this.handleFormChange} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formCity">
                                <Form.Label>City</Form.Label>
                                <Form.Control type="input" name="propertyCity" value={this.state.input.propertyCity} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.propertyCity} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formState">
                                <Form.Label>State</Form.Label>
                                <Form.Select name="propertyState" value={this.state.input.propertyState} onChange={this.handleFormChange}>
                                    <option value="DC">DC</option>
                                    <option value="MD">MD</option>
                                    <option value="VA">VA</option>
                                    <option value="WV">WV</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formZip">
                                <Form.Label>Zip</Form.Label>
                                <Form.Control type="text" name="propertyZip" value={this.state.input.propertyZip} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.propertyZip} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formPurchaseOrder">
                                <Form.Label>Purchase order (PO) # (if applicable)</Form.Label>
                                <Form.Control name="requestPurchaseOrder" value={this.state.input.requestPurchaseOrder} onChange={this.handleFormChange} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formWorkOrder">
                                <Form.Label>Work order # (if applicable)</Form.Label>
                                <Form.Control name="requestWorkOrder" value={this.state.input.requestWorkOrder} onChange={this.handleFormChange} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formUrgency">
                                <Form.Label>Please select request urgency</Form.Label>
                                <Form.Select name="requestUrgency" value={this.state.input.requestUrgency} onChange={this.handleFormChange}>
                                    <option value="Same day service">Same day service</option>
                                    <option value="Within 48 hours">Within 48 hours</option>
                                    <option value="Within 5 business days">Within 5 business days</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="form-row-secondary">
                            <Form.Group className="mb-3" controlId="formRequestDetails">
                                <Form.Label>Please provide service request details</Form.Label>
                            <Form.Control as="textarea" rows={3} name="requestDetails" value={this.state.input.requestDetails} onChange={this.handleFormChange}
                                isInvalid={!!this.state.errors.requestDetails} />
                        </Form.Group>
                        <Col md>
                            <Form.Group style={{ marginTop: -10 }} controlId="formAttachment" className="mb-3">
                                <Form.Label>Attachments</Form.Label>
                                <Form.Control type="file" ref={this.fileControl} multiple />
                            </Form.Group>
                        </Col>
                    </Row>


                    <Row className="form-row-first">
                        <Col md={6} xs={12}>
                            <Form.Label className="form-header">Requestor Information</Form.Label>
                        </Col>
                    </Row>

                    <Row className="form-row-first">
                        <Col md>
                            <Form.Group className="mb-3" controlId="requestorFirstname">
                                <Form.Label>First name</Form.Label>
                                <Form.Control type="input" name="requestorFirstname" value={this.state.input.requestorFirstname} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.requestorFirstname} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="requestorLastname">
                                <Form.Label>Last name</Form.Label>
                                <Form.Control type="input" name="requestorLastname" value={this.state.input.requestorLastname} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.requestorLastname} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md>
                            <Form.Group className="mb-3" controlId="requestorEmail">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control type="input" name="requestorEmail" value={this.state.input.requestorEmail} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.requestorEmail} />
                                <Form.Control.Feedback type='invalid'>
                                    {this.state.errors.requestorEmail}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="requestorPhone">
                                <Form.Label>Phone number</Form.Label>
                                <Form.Control type="phone" name="requestorPhone" value={this.state.input.requestorPhone} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.requestorPhone} />
                                <Form.Control.Feedback type='invalid'>
                                    {this.state.errors.requestorPhone}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="form-row-first">
                        <Col md={6} xs={12}>
                            <Form.Label className="form-header">Service Point of Contact</Form.Label>
                        </Col>
                    </Row>

                    <Row className="form-row-secondary">
                        <Col md={6} xs={12}>
                            <Form.Check type="checkbox" name="spocSameAsCheckbox" onChange={this.handleSameAsCheckbox} label="Same as requestor information?" />
                        </Col>
                    </Row>
                    <Row className="form-row-first">
                        <Col md>
                            <Form.Group className="mb-3" controlId="spocFirstname">
                                <Form.Label>First name</Form.Label>
                                <Form.Control type="input" name="spocFirstname" value={this.state.input.spocFirstname} onChange={this.handleFormChange} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="spocLastname">
                                <Form.Label>Last name</Form.Label>
                                <Form.Control type="input" name="spocLastname" value={this.state.input.spocLastname} onChange={this.handleFormChange} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md>
                            <Form.Group className="mb-3" controlId="spocEmail">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control type="input" name="spocEmail" value={this.state.input.spocEmail} onChange={this.handleFormChange} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="spocPhone">
                                <Form.Label>Phone number</Form.Label>
                                <Form.Control type="phone" name="spocPhone" value={this.state.input.spocPhone} onChange={this.handleFormChange} />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="form-row-first">
                        <Col md={6} xs={12}>
                            <Form.Label className="form-header">Billing Point of Contact</Form.Label>
                        </Col>
                    </Row>

                    <Row className="form-row-secondary">
                        <Col md={6} xs={12}>
                            <Form.Check type="checkbox" name="bpocSameAsCheckbox" onChange={this.handleSameAsCheckbox} label="Same as requestor information?" />
                        </Col>
                    </Row>
                    <Row className="form-row-first">
                        <Col md>
                            <Form.Group className="mb-3" controlId="bpocFirstname">
                                <Form.Label>First name</Form.Label>
                                <Form.Control type="input" name="bpocFirstname" value={this.state.input.bpocFirstname} onChange={this.handleFormChange} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="bpocLastname">
                                <Form.Label>Last name</Form.Label>
                                <Form.Control type="input" name="bpocLastname" value={this.state.input.bpocLastname} onChange={this.handleFormChange} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md>
                            <Form.Group className="mb-3" controlId="bpocEmail">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control type="input" name="bpocEmail" value={this.state.input.bpocEmail} onChange={this.handleFormChange} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="bpocPhone">
                                <Form.Label>Phone number</Form.Label>
                                <Form.Control type="phone" name="bpocPhone" value={this.state.input.bpocPhone} onChange={this.handleFormChange} />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="form-row-first">
                        <Col md={6} xs={12}>
                            <Form.Label className="form-header">Equipment (if known)</Form.Label>
                        </Col>
                    </Row>
                    <Row className="mb3">
                        <Col md>
                            <ViewEquipmentTable ref={ n => this.equipmentTable = n}/>
                        </Col>
                    </Row>
                    {this.showButton()}
                </Form>
            </div>
        );
    }
}

export default ServiceRequestForm;